<template>
  <v-card flat class="layout row wrap pa-3 justify-space-between">
    <v-textarea
      auto-grow
      hint="Auto Save After 5 Second"
      class="flex xs12 mt-3"
      v-model="value.introduction"
      label="Introduction about CSO"
    />
    <projects />
    <members type="member" class="flex xs12" />
    <members type="interviewer" class="flex xs12" />
    <v-flex xs12 row wrap px-0 mt-4 class="di-flex justify-end">
      <v-btn flat @click="$emit('back')">Back</v-btn>
      <v-btn class="mr-0" color="primary" @click="$emit('next')">Next</v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import members from "./members";
import projects from "./projects";
import debounce from "@/plugins/v-debounce";

export default {
  name: "introduction",
  components: { projects, members },
  props: { value: Object },
  data() {
    return {
      project: {},
      items: [],
      dialog: false,
      loading: false,
      editedIndex: -1,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    };
  },
  computed: {
    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "100px" },
      { text: vm.$t("name"), value: "name" },
      { text: vm.$t("start_date"), value: "start_date" },
      { text: vm.$t("end_date"), value: "end_date" },
      { text: vm.$t("location"), value: "location" },
      { text: vm.$t("budget"), value: "budget" },
      { text: vm.$t("donor"), value: "donor" },
      { text: vm.$t("core_objectives"), value: "core_objectives" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ],

    formTitle: vm => (vm.editedIndex > -1 ? "Edit Project" : "New Project")
  },

  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert(`/projects/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.project = Object.assign({}, item);
      this.dialog = true;
    },

    reset() {
      this.project = {
        id: null,
        name: null,
        donor: null,
        budget: null,
        location: null,
        end_date: null,
        start_date: null,
        core_objectives: null,
        CSO_id: this.$route.params.id
      };
      this.dialog = false;
      this.loading = false;
      this.editedIndex = -1;
    },

    projectSaved(value) {
      if (this.editedIndex > -1)
        Object.assign(this.items[this.editedIndex], value);
      else this.items.push(value);
      this.reset();
    },

    patch() {
      this.loading = true;
      this.axios
        .patch(`/CSOs/${this.value.id}`, {
          introduction: this.value.introduction
        })
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
    }
  },

  created() {
    this.reset();
    let CSO_id = this.$route.params.id;
    this.axios.get(`projects?CSO_id=${CSO_id}`).then(res => {
      this.items = res.data.data;
    });
  },

  watch: {
    "value.introduction": debounce(function() {
      this.patch();
    }, 500)
  }
};
</script>
